<div class="box">
    <h3 mat-dialog-title>Warning</h3>
    <div mat-dialog-content class="content">
        <span>You are about to reject the user.</span>
        <div class="input" fxFlex="100">
            <app-select-field [isEditable]="true" [(ngModel)]="selectedReason" [name]="'rejectReason'"
                [displayField]="'description'" [options]="rejectionReasonList" class="align-items-center"
                [errors]="errorObj.rejection_reason" ppaceholder="Select Reject Reason">
            </app-select-field>
        </div>
        <div class="imgWrapper">
            <img src="assets/images/dailog-box/warning.jpg " alt="">
        </div>
        <span class="description" [innerHTML]="'Are you sure you want to continue?'"></span>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button class="Save" (click)="closeDialog()" (mouseover)="this.set = true"
            (mouseout)="this.set = false">Cancel</button>
        <button mat-raised-button class="Save" [disabled]="disableSave" (click)="rejectUser()">
            <span *ngIf="!disableSave">
                Reject User
            </span>
            <div *ngIf="disableSave" class="p03">
                <i class="flaticon-loading spin"></i>
                <span>Rejecting User ...</span>
            </div>
        </button>
    </div>
</div>
<div class="bg" [class.set]="set"></div>